(function ($) {
    class W4D_Cart {
        constructor() {
            this.$body = $(document.body);

            this.bindEvents();
            this.setupCartUpdateListener();
        }

        bindEvents() {

        }

        setupCartUpdateListener() {
            this.$body.on('updated_cart_totals wc_cart_emptied', (e) => {
                this.$updateCartButton = $('[name="update_cart"]');
                const itemCount = e.type === 'wc_cart_emptied' ? 0 : $('.cart_item').length;
                W4D_FrontendHelper.updateCartIcon(itemCount);
                
            });
        }
    }

    $(document).ready(() => new W4D_Cart());
})(jQuery);
